import { useContext, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext, AuthContextState } from '../context/AuthContext';
import { LOGIN_ROUTE } from '../config/constants';

export interface PrivateRouteProps {
  children: JSX.Element
};

// wrapper for private routes, i.e. routes that are only accessible after authentication
const PrivateRoute = (props: PrivateRouteProps): JSX.Element | null => {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAuthenticated, fetchMe } = useContext(AuthContext) as AuthContextState;
  const authFuncCalled = useRef<boolean>(false);

  useEffect(() => {
    if (authFuncCalled.current) {
      return;
    }

    authFuncCalled.current = true

    // set up login url
    const params = new URLSearchParams();
    params.append('next', location.pathname + location.search);

    const authPath = LOGIN_ROUTE + '?' + params.toString();

    checkAuthenticated().then(
      (value: boolean) => {
        if (!value) {
          navigate(authPath);
        } else {
          fetchMe();
        }
      }
    ).catch(() => navigate(authPath));
  }, [navigate, checkAuthenticated, fetchMe, authFuncCalled, location]);

  return props.children;
};

export default PrivateRoute;
